export function useReservationResources() {
  return window.ticketreservation_resources;
}